import axios from 'axios';

const DEEZER_CLIENT_ID = process.env.REACT_APP_DEEZER_CLIENT_ID;
const DEEZER_REDIRECT_URI =
  process.env.REACT_APP_DEEZER_REDIRECT_URI || 'http://localhost:3000/callback';
const DEEZER_SCOPE = 'basic_access,email';

class DeezerService {
  static initiateLogin(platform: 'web' | 'mobile' = 'web') {
    const authUrl = `https://connect.deezer.com/oauth/auth.php?app_id=${DEEZER_CLIENT_ID}&redirect_uri=${encodeURIComponent(
      DEEZER_REDIRECT_URI
    )}&scope=${DEEZER_SCOPE}`;

    if (platform === 'mobile') {
      window.location.href = `deezer://oauth?app_id=${DEEZER_CLIENT_ID}&redirect_uri=${encodeURIComponent(
        DEEZER_REDIRECT_URI
      )}&scope=${DEEZER_SCOPE}`;
    } else {
      window.location.href = authUrl;
    }
  }

  static async checkToken(token: string) {
    try {
      const response = await axios.get('https://api.deezer.com/user/me', {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.data) {
        return {
          valid: true,
          user: {
            id: response.data.id.toString(),
            display_name: response.data.name,
            email: response.data.email,
            images: [
              {
                url: response.data.picture_medium,
                height: 250,
                width: 250,
              },
            ],
          },
        };
      }

      return { valid: false };
    } catch (error) {
      console.error('Erreur lors de la vérification du token Deezer:', error);
      return { valid: false };
    }
  }
}

export default DeezerService;
